module.exports = __webpack_public_path__ + "img/089a188109c37652994ebc208b6f318c.png";